"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrongParamTypeException = void 0;
const string_1 = require("../../../helpers/string");
class WrongParamTypeException extends TypeError {
    static MESSAGE = 'Wrong type of param (??) passed to method (??)';
    static CODE = 'WRONG_PARAM_TYPE';
    constructor(method, paramName) {
        super((0, string_1.formatString)(WrongParamTypeException.MESSAGE, paramName, method));
    }
}
exports.WrongParamTypeException = WrongParamTypeException;
